// src/pages/team/CoinGaleries.jsx
// Coin « Galeries » — suivi galeries, demandes de galeries, import maisons de vente.
// Compose des composants déjà autonomes. Accès : route staff + coin 'galeries'.
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { hasCoin, COIN_BY_KEY } from "../../config/teamCoins";
import GalleryTrackingSection from "../../components/team/GalleryTrackingSection";
import GalleryRequestsQueue from "../../components/team/GalleryRequestsQueue";
import QuickCreateAuctionForm from "../../components/team/QuickCreateAuctionForm";
import QuickCreateFairForm from "../../components/team/QuickCreateFairForm";
import LotsCsvUploader from "../../components/team/LotsCsvUploader";
import ImportAuction from "../../components/team/ImportAuction.jsx";

const COIN = COIN_BY_KEY.galeries;

function Block({ title, subtitle, children }) {
  return (
    <div>
      <div className="mb-4">
        <h3 className="text-xl font-light text-gray-900">{title}</h3>
        {subtitle && <p className="mt-0.5 text-sm text-gray-500">{subtitle}</p>}
      </div>
      <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">{children}</div>
    </div>
  );
}

export default function CoinGaleries() {
  const { profile, profileLoading } = useAuth();

  if (profileLoading) {
    return <div className="flex min-h-screen items-center justify-center bg-[#f9f7f4]"><div className="h-10 w-10 animate-spin rounded-full border-b-2 border-gray-900" /></div>;
  }
  if (!hasCoin(profile, "galeries")) {
    return (
      <div className="mx-auto max-w-lg px-6 py-24 text-center">
        <div className="text-4xl" aria-hidden>🔒</div>
        <h1 className="mt-4 font-serif text-2xl font-semibold text-gray-900">Accès non accordé</h1>
        <p className="mt-2 text-sm text-gray-600">Le coin « Galeries » ne vous a pas été attribué. Demandez-le à un administrateur.</p>
        <Link to="/team/dashboard" className="mt-6 inline-block rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-800">Retour à mon espace</Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f9f7f4]">
      <header className="border-b border-gray-200 bg-white">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-5">
          <div className="flex items-center gap-3">
            <span className="text-3xl" aria-hidden>{COIN.emoji}</span>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-rose-500">Coin Galeries</p>
              <h1 className="font-serif text-2xl font-semibold text-gray-950">{COIN.title}</h1>
            </div>
          </div>
          <Link to="/team/dashboard" className="rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">← Mon espace</Link>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-6 py-8">
        <div className="space-y-12">
          <div>
            <div className="mb-4">
              <h3 className="text-xl font-light text-gray-900">Import maisons de vente</h3>
              <p className="mt-0.5 text-sm text-gray-500">Création et import express (enchères, foires, lots).</p>
            </div>
            <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm"><QuickCreateAuctionForm /></div>
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm"><QuickCreateFairForm /></div>
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm"><LotsCsvUploader /></div>
              <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm"><ImportAuction /></div>
            </div>
          </div>

          <Block title="Suivi galeries" subtitle="Artistes suivis + expos/actus par galerie.">
            <GalleryTrackingSection />
          </Block>

          <Block title="Demandes de galeries" subtitle="Galeries demandées par les clients.">
            <GalleryRequestsQueue />
          </Block>
        </div>
      </main>
    </div>
  );
}
